import { Box, Typography } from '@mui/material';
import React from 'react';
import { MoLink } from './MoLink';
import { MotivoSupervisorBadge } from './MotivoSupervisorBadge';

type SupervisorNameProps = {
  name: string;
  to?: string;
  showBadge?: boolean;
};

export function SupervisorName({ name, to, showBadge = false }: SupervisorNameProps) {
  return (
    <Box component="span" display="inline-flex" alignItems="center" gap={1}>
      {to ? (
        <MoLink to={to}>{name}</MoLink>
      ) : (
        <Typography component="span" fontWeight="bold">
          {name}
        </Typography>
      )}
      {showBadge && <MotivoSupervisorBadge />}
    </Box>
  );
}
